import { useIsMobile } from './useIsMobile';
import { useAltezzaPubblicata } from './useAltezzaPubblicata';

/** Il nome della variabile scritta su `:root`. Il ripiego sta in index.css. */
const VARIABILE = '--altezza-barra';

/**
 * Quanto è alta la barra in basso, DAVVERO, detto al CSS.
 *
 * `--bottom-nav-height: 64px` non è l'altezza della barra: è il suo pavimento.
 * La barra ha `min-height` e non `height` (Sidebar.css) apposta, perché
 * «STARTSEITE» e «STRONA GŁÓWNA» vanno a capo e due righe più icona superano i
 * 64px. Chiunque abbia bisogno di sapere dove finisce la barra — il foglio di
 * «Gioca», che ci si posa sopra; il `padding-bottom` della pagina, che le deve
 * stare fuori — con quel numero si sbaglia proprio nelle lingue che il
 * `min-height` è lì a proteggere.
 *
 * Quindi si misura. Il valore va su `:root` come stile inline, che scavalca la
 * dichiarazione di index.css; il cleanup lo toglie e il ripiego torna da solo.
 *
 * Solo dove la barra È in basso (≤768px): sul desktop quello stesso `<aside>` è
 * una colonna alta quanto lo schermo, e pubblicarne l'altezza come «altezza
 * della barra» sarebbe una bugia peggiore di quella che questo hook esiste per
 * togliere.
 *
 * Quel ≤768 citava `barraInBasso` in App.tsx, che non esiste più da un pezzo
 * (`foglio-gioca.cablaggio.test.ts` asserisce che sia sparito). Il compagno vero
 * è `Sidebar.css`, e da oggi quel numero non è più «il breakpoint di questo
 * hook»: è IL confine mobile/desktop dell'app, uno solo, sorvegliato da
 * `un-confine-solo.test.ts`.
 *
 * La misura vera e propria — ResizeObserver, guardia dello zero, pulizia — sta
 * in `useAltezzaPubblicata`, che e' lo stesso meccanismo usato dalle bande di
 * bottoni in fondo alle pagine. Qui resta cio' che e' SOLO della barra: il nome
 * della variabile e il confine mobile/desktop.
 *
 * @param elemento l'`<aside class="sidebar">`. Sidebar.tsx è l'unico che lo possiede.
 */
export function useAltezzaBarra(elemento: HTMLElement | null): void {
  const inBasso = useIsMobile(768);
  useAltezzaPubblicata(inBasso ? elemento : null, VARIABILE);
}
